import { FaBars, FaCar, FaCarSide, FaChevronDown, FaCartPlus, FaCube, FaCubes, FaHome, FaPlusCircle, FaPlusSquare, FaStore, FaTag, FaTags, FaTimes, FaTools, FaTrademark, FaUserCog, FaUserPlus, FaUsers, FaUserShield, FaUserTie, FaWarehouse, FaWrench } from 'react-icons/fa';
import { FaCartShopping } from "react-icons/fa6";
import { MdCategory } from "react-icons/md";
import { FcStatistics } from "react-icons/fc";
import { MdOutlineCategory } from "react-icons/md";
import { CgAttribution } from "react-icons/cg";
import { FaBoxArchive } from "react-icons/fa6";
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
import { IoNotifications } from "react-icons/io5";
import { FaCartArrowDown } from "react-icons/fa";
import { LiaAdSolid } from "react-icons/lia";
import { FaUserAlt } from "react-icons/fa";
import { FaPager } from "react-icons/fa";
import { IoNewspaperOutline } from "react-icons/io5";
import { AiTwotoneDatabase } from "react-icons/ai";
import { MdOutlineInput } from "react-icons/md";
import { RiVisaLine } from "react-icons/ri";
import { BsFillSendFill } from "react-icons/bs";
import { FaArrowDown } from "react-icons/fa6";
import { ImArrowUpRight } from "react-icons/im";
import { ImArrowDownLeft } from "react-icons/im";
import { IoStorefront } from "react-icons/io5";
import { MdReport } from "react-icons/md";
import { TbTruckDelivery } from "react-icons/tb";
import { FaProductHunt } from "react-icons/fa6";
import { MdDeliveryDining } from "react-icons/md";
import { BiSolidCoupon } from "react-icons/bi";
import i18n from "../lib/i18n"; // path may differ

const t = i18n.t.bind(i18n); 

const navigationItems = [
    // --- SECTION: ANALYTICS ---
    { 
        icon: <FaHome />, 
        section: "Analytics", 
        permissions: "statistics.view", 
        text: t("nav.dashboard"), 
        to: "/" 
    },

    // --- SECTION: ORDER MANAGEMENT ---
    { 
        icon: <FaCartArrowDown />, 
        section: "Order Management", 
        permissions: "orders.view", 
        text: t("nav.orders"), 
        to: "/orders" 
    },

    // --- SECTION: CATALOG & INVENTORY ---
    {
        icon: <IoStorefront />,
        permissions: "stores.view",
        text: t("nav.stores"),
        section: "Catalog & Inventory",
        subItems: [
            { icon: <IoStorefront />, text: t("nav.stores"), to: "/stores", permissions: "stores.view" },
            { icon: <FaPlusCircle />, text: t("nav.add_stores"), to: "/stores/add", permissions: "stores.create" }
        ]
    },
    {
        icon: <MdOutlineCategory />,
        permissions: "category.view",
        text: t("nav.categories"),
        section: "Catalog & Inventory",
        subItems: [
            { icon: <MdOutlineCategory />, text: t("nav.categories"), to: "/categories", permissions: "category.view" },
            { icon: <FaPlusCircle />, text: t("nav.add_category"), to: "/categories/add", permissions: "category.create" }
        ]
    },
    {
        icon: <FaProductHunt />,
        permissions: "product.view",
        text: t("nav.products"),
        section: "Catalog & Inventory",
        subItems: [
            { icon: <FaProductHunt />, text: t("nav.products"), to: "/products", permissions: "product.view" },
            { icon: <FaPlusCircle />, text: t("nav.add_products"), to: "/products/add", permissions: "product.view" }
        ]
    },

    // --- SECTION: LOGISTICS & DELIVERY ---
    {
        icon: <MdDeliveryDining />,
        permissions: "delivery.view",
        text: t("nav.deliveryBoys"),
        section: "Logistics & Delivery",
        subItems: [
            { icon: <MdDeliveryDining />, text: t("nav.deliveryBoys"), to: "/deliveryBoys", permissions: "delivery.view" },
            { icon: <FaPlusCircle />, text: t("nav.add_deliveryBoys"), to: "/deliveryBoys/add", permissions: "delivery.create" }
        ]
    },
    {
        icon: <TbTruckDelivery />,
        permissions: "price.view",
        text: t("nav.delivery_price"),
        section: "Logistics & Delivery",
        subItems: [
            { icon: <TbTruckDelivery />, text: t("nav.delivery_price"), to: "/prices", permissions: "price.view" },
            { icon: <FaPlusCircle />, text: t("nav.add_delivery_price"), to: "/prices/add", permissions: "price.create" }
        ]
    },

    // --- SECTION: MARKETING & PROMOTION ---
    {
        icon: <BiSolidCoupon />,
        permissions: "coupons.view",
        text: t("nav.copons"),
        section: "Marketing & Promotion",
        subItems: [
            { icon: <BiSolidCoupon />, text: t("nav.copons"), to: "/copons", permissions: "coupons.view" },
            { icon: <FaPlusCircle />, text: t("nav.add_copons"), to: "/copons/add", permissions: "coupons.create" }
        ]
    },
    {
        icon: <IoNotifications />,
        permissions: "alert.view",
        text: t("nav.notifications"),
        section: "Marketing & Promotion",
        subItems: [
            { icon: <ImArrowDownLeft />, text: t("nav.incoming_notifications"), to: "/notifications", permissions: "alert.view" },
            { icon: <ImArrowUpRight />, text: t("nav.outgoing_notifications"), to: "/notifications/outgoing", permissions: "alert.view" },
            { icon: <FaPlusCircle />, text: t("nav.send_notification"), to: "/notifications/add", permissions: "alert.create" }
        ]
    },

    // --- SECTION: USERS & REPORTS ---
    { 
        icon: <FaUserAlt />, 
        section: "Users & Reports", 
        permissions: "user.view", 
        text: t("nav.users"), 
        to: "/users" 
    },
    { 
        icon: <MdReport className='text-[22px]' />, 
        section: "Users & Reports", 
        permissions: "product.view", 
        text: t("nav.reports"), 
        to: "/reports" 
    },

    // --- SECTION: ADMINISTRATION (HR) ---
    {
        icon: <FaUsers />,
        permissions: "employees.view",
        section: "Administration",
        text: t("nav.employees"),
        subItems: [
            { icon: <FaUserTie />, text: t("nav.employees"), to: "/employees", permissions: "employees.view" },
            { icon: <FaUserPlus />, text: t("nav.add_employee"), to: "/employees/add", permissions: "employees.create" }
        ]
    },
    {
        icon: <FaUserShield />,
        permissions: "roles.view",
        text: t("nav.roles"),
        section: "Administration",
        subItems: [
            { icon: <FaUserCog />, text: t("nav.roles"), to: "/roles", permissions: "roles.view" },
            { icon: <FaPlusCircle />, text: t("nav.add_role"), to: "/roles/add", permissions: "roles.create" }
        ]
    },
];

  const categoiresColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.name_ar"), key: "name.ar" },
    { header: t("columns.name_en"), key: "name.en" },
    { header: t("columns.parent_id"), key: "category_parent_id" },
    { header: t("columns.parent_name"), key: "category_parent_name" },
    { header: t("columns.status"), key: "active" },
  ];

  const coponsColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.code"), key: "code" },
    { header: t("columns.discount_type"), key: "discount_type" },
    { header: t("columns.value"), key: "value" },
    { header: t("columns.usage_limit"), key: "usage_limit" },
    { header: t("columns.user_limit"), key: "user_limit" },
    { header: t("columns.usage_count"), key: "usage_count" },
    { header: t("columns.start_at"), key: "start_at" },
    { header: t("columns.end_at"), key: "end_at" },
    { header: t("columns.is_active"), key: "is_active" },
    { header: t("columns.created_at"), key: "created_at" },
  ];

  const productsColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.photo"), key: "main_photo" },
    { header: t("columns.name_ar"), key: "title.ar" },
    { header: t("columns.name_en"), key: "title.en" },
    { header: t("columns.category_name"), key: "category" },
    { header: t("columns.sub_category_name"), key: "sub_category" },
    { header: t("columns.price"), key: "price" },
    { header: t("columns.final_price"), key: "final_price" },
    { header: t("status.accept"), key: "accept" },
  ];

  const ordersColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.user"), key: "user" },
    { header: t("columns.store"), key: "store" },
    { header: t("columns.delivery"), key: "delivery" },
    { header: t("columns.total"), key: "total" },
    { header: t("columns.storeFee"), key: "storeFee" },
    { header: t("columns.deliveryFee"), key: "deliveryFee" },
    { header: t("columns.store_status"), key: "store_status" },
    { header: t("columns.delivery_status"), key: "delivery_status" },
    { header: t("columns.date"), key: "date" },
    { header: t("columns.time"), key: "time" },
  ];

  const statusOfProducts = [
    { id: "1", name: t("status.accept") },
    { id: "0", name: t("status.notaccept") },
  ];

  const statusOfCopons = [
    { id: "percent", name: t("status.percent") },
    { id: "fixed", name: t("status.fixed") },
  ];

  const pricesColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.min_distance"), key: "min_distance" },
    { header: t("columns.max_distance"), key: "max_distance" },
    { header: t("columns.price"), key: "price" },
  ];

  const storesColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.photo"), key: "photo" },
    { header: t("columns.name"), key: "name" },
    { header: t("columns.phone_number"), key: "phone" },
    { header: t("columns.status"), key: "active" },
    { header: t("columns.topResult"), key: "topResult" },
    { header: t("columns.created_at"), key: "created_at" },
  ];

  const deliveryBoysColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.name"), key: "name" },
    { header: t("columns.phone_number"), key: "phone" },
    { header: t("columns.wallet_balance"), key: "wallet_balance" },
    { header: t("columns.status"), key: "available" },
    { header: t("columns.created_at"), key: "created_at" },
  ];

  const statusOfDeliveryBoys = [
    { id: "1", name: t("status.active") },
    { id: "0", name: t("status.inactive") },
  ];

  const statusOfTransactions = [
    { id: "deposit", name: t("status.deposit") },
    { id: "withdrawal", name: t("status.withdrawal") },
    { id: "penalty", name: t("status.penalty") },
    { id: "bonus", name: t("status.bonus") },
  ];

  const statusOfCategories = [
    { id: "main", name: t("status.main") },
    { id: "sub", name: t("status.sub") },
  ];

  // 🟢 Inputs
  const inputsColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.name_ar"), key: "label.ar" },
    { header: t("columns.name_en"), key: "label.en" },
    { header: t("columns.type"), key: "type" },
    { header: t("columns.required"), key: "required" },
    { header: t("columns.regex"), key: "regex" },
  ];

  const typeOfInputs = [
    { id: "text", name: t("types.text") },
    { id: "number", name: t("types.number") },
    { id: "check box", name: t("types.checkbox") },
  ];

  // 🟢 Packages
  const packagesColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.title_ar"), key: "title.ar" },
    { header: t("columns.title_en"), key: "title.en" },
    { header: t("columns.sub_category_name"), key: "sub_category_name" },
    { header: t("columns.price"), key: "price" },
    { header: t("columns.duration"), key: "duration" },
    { header: t("columns.top_result"), key: "topResult" },
    { header: t("columns.position"), key: "position" },
  ];

  const positionOfPackags = [
    { id: "1", name: t("positions.normal") },
    { id: "2", name: t("positions.home") },
  ];

  const shapOfPackags = [
    { id: "1", name: t("positions.normal_shape") },
    { id: "2", name: t("positions.vip_shape") },
  ];

  const TopResultOfPackags = [
    { id: "1", name: t("topResults.primary") },
    { id: "0", name: t("topResults.secondary") },
  ];

  // 🟢 Users
  const usersColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.name"), key: "name" },
    { header: t("columns.phone_number"), key: "phone" },
    { header: t("columns.orders_completed"), key: "orders_completed" },
    { header: t("columns.last_seen"), key: "last_seen" },
    { header: t("columns.created_at"), key: "created_at" },
  ];

  const stateOfusers = [
    { id: "1", name: t("states.active") },
    { id: "2", name: t("states.banned") },
    { id: "3", name: t("states.suspended") },
  ];

  const typeOfUsers = [
    { id: "user", name: t("types.user") },
    { id: "company", name: t("types.company") },
  ];

  const stateOfOrders = [
    { id: "PENDING", name: t("status.pending") },
    { id: "IN_PROGRESS", name: t("status.IN_PROGRESS") },
    { id: "COMPLETED", name: t("status.COMPLETED") },
    { id: "CANCELLED", name: t("status.CANCELLED") },
    { id: "GO_TO_STORE", name: t("status.GO_TO_STORE") },
    { id: "AT_THE_STORE", name: t("status.AT_THE_STORE") },
    { id: "ON_THE_WAY", name: t("status.ON_THE_WAY") },
    { id: "DRIVER_ARRIVED", name: t("status.DRIVER_ARRIVED") },
  ];

  const stateOfStores = [
    { id: "IN_PROGRESS", name: t("status.IN_PROGRESS") },
    { id: "PENDING", name: t("status.PENDING") },
    { id: "COMPLETED", name: t("status.COMPLETED") },
    { id: "CANCELLED", name: t("status.CANCELLED") },
  ];

  const stateOfDeliveryBoy = [
    { id: "PENDING", name: t("status.PENDING") },
    { id: "GO TO STORE", name: t("status.GO_TO_STORE") },
    { id: "AT THE STORE", name: t("status.AT_THE_STORE") },
    { id: "ON THE WAY", name: t("status.ON_THE_WAY") },
    { id: "DRIVER ARRIVED", name: t("status.DRIVER_ARRIVED") },
    { id: "COMPLETED", name: t("status.COMPLETED") },
  ];

  // 🟢 Ads
  const adsColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.photo"), key: "main_photo" },
    { header: t("columns.full_name"), key: "full_name" },
    { header: t("columns.title_en"), key: "title" },
    { header: t("columns.category_name"), key: "category_name" },
    { header: t("columns.sub_category_name"), key: "sub_category_name" },
    { header: t("columns.price"), key: "price" },
    { header: t("columns.publish_at"), key: "publish_at" },
    { header: t("columns.order_status"), key: "order" },
  ];

  const typeOfcurrency = [
    { id: "usd", name: t("types.usd") },
    { id: "sp", name: t("types.sp") },
  ];

  const typeOfAds = [
    { id: "CONFIRM", name: t("status.confirm") },
    { id: "PENDING", name: t("status.pending") },
    { id: "SoldRemoved", name: t("status.sold_removed") },
    { id: "REJECT", name: t("status.reject") },
  ];

  // 🟢 Blog Categories
  const categoriesBolgColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.name_ar"), key: "name.ar" },
    { header: t("columns.name_en"), key: "name.en" },
    { header: t("columns.isHome"), key: "isHome" },
    { header: t("columns.status"), key: "active" },
  ];

  const statusOfCategoriesBlog = [
    { id: "0", name: t("status.inactive") },
    { id: "1", name: t("status.active") },
  ];

  const positionOfCategoiresBlog = [
    { id: "0", name: t("positions.normal") },
    { id: "1", name: t("positions.home") },
  ];

  // 🟢 Blogs
  const bolgColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.photo"), key: "image" },
    { header: t("columns.title_ar"), key: "title.ar" },
    { header: t("columns.title_en"), key: "title.en" },
    { header: t("columns.category_name"), key: "category_name" },
  ];

  // 🟢 Payment Methods
  const paymentMethodColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.name_en"), key: "name" },
    { header: t("columns.status"), key: "active" },
  ];

  // 🟢 Roles
  const rolesColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.name_en"), key: "name" },
  ];

  // 🟢 Employees
  const employeesColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.full_name"), key: "name" },
    { header: t("columns.email"), key: "email" },
    { header: t("columns.role_id"), key: "role_id" },
    { header: t("columns.role_name"), key: "role_name" },
  ];

  // 🟢 Reports
  const reportsColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.reported_type"), key: "reported_type" },
    { header: t("columns.user_by_name"), key: "user_by.name" },
    { header: t("columns.reported_user_name"), key: "reported_user.name" },
    { header: t("columns.ad_name"), key: "reported_ad.title" },
    { header: t("columns.reason"), key: "report.report" },
    { header: t("columns.created_at"), key: "created_at" },
    { header: t("columns.status"), key: "check" },
  ];

  
  const reportType = [
    {name: t("types.user_report") , id : "user"},
    {name: t("types.chat") , id : "chat"},
    {name: t("types.ad") , id : "ad"}
  ];
  
  // 🟢 Number of Results
  const numberOfData = [
    { id: "10", name: t("resultsCount.10") },
    { id: "100", name: t("resultsCount.100") },
    { id: "200", name: t("resultsCount.200") },
    { id: "500", name: t("resultsCount.500") },
    { id: "1000", name: t("resultsCount.1000") },
    { id: "10000", name: t("resultsCount.10000") },
  ];
  
  const pageColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.title_ar"), key: "name.ar" },
    { header: t("columns.title_en"), key: "name.en" },
    { header: t("columns.created_at"), key: "created_at" },
  ];
  
  const pageSectionColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.title_ar"), key: "title.ar" },
    { header: t("columns.title_ar"), key: "title.en" },
    { header: t("columns.description_ar"), key: "description.ar" },
    { header: t("columns.description_en"), key: "description.en" },
    { header: t("columns.page_name"), key: "page_name" },
  ];


export {navigationItems, categoiresColumns, pricesColumns, statusOfCategories, inputsColumns, typeOfInputs, packagesColumns, positionOfPackags, shapOfPackags, TopResultOfPackags, usersColumns, stateOfusers, ordersColumns, stateOfOrders, adsColumns, typeOfUsers, typeOfAds, categoriesBolgColumns, bolgColumns, statusOfCategoriesBlog, positionOfCategoiresBlog, paymentMethodColumns, rolesColumns, employeesColumns, numberOfData, typeOfcurrency, reportsColumns, reportType, pageColumns, pageSectionColumns, storesColumns, deliveryBoysColumns, statusOfDeliveryBoys, productsColumns, statusOfProducts, stateOfStores, stateOfDeliveryBoy, coponsColumns, statusOfCopons, statusOfTransactions};
